import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface BookbindingCollection {
  collectionId: number
  collectionNo: string
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  volume: string
  volumeNumber: string
  volumeTotal: string
  volumeDateLabel: string
  volumeSpecial: string
  collectionFlag: CollectionFlag
  revision: number
}

export function BookbindingCollectionFromJSON(
  json: any
): BookbindingCollection {
  return {
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    volume: exists(json, 'volume') ? json.volume : '',
    volumeNumber: exists(json, 'volume_number') ? json.volume_number : '',
    volumeTotal: exists(json, 'volume_total') ? json.volume_total : '',
    volumeDateLabel: exists(json, 'volume_date_label')
      ? json.volume_date_label
      : '',
    volumeSpecial: exists(json, 'volume_special') ? json.volume_special : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
